import { BBCommonProps, BBUiConfig } from 'types/story';
import { FieldBBErrorType } from '../../BuildingBlocks/Fields/constants';

export const initialState: {
	isValid: boolean;
	uploadFilesProcessQueue: string[];
	errors: {
		[key: string]: string[];
	};
} = {
	isValid: true,
	uploadFilesProcessQueue: [],
	errors: {},
};
export type FormDataT = {
	[fieldId: string]: {
		name: string;
		type: string;
		// field value
		data: string;
		file?: File | null;
		attributes: { id: string; checked?: boolean };
	};
};
export type ValidationMap = {
	[FieldBBErrorType.required]: File | string | boolean;
	[FieldBBErrorType.email]: string;
	[FieldBBErrorType.tel]: string;
	[FieldBBErrorType.fullName]: string;
	[FieldBBErrorType.fileSize]: File | null;
	[FieldBBErrorType.invalidFileType]: File | null;
	[FieldBBErrorType.genericError]: unknown;
};
export type ValidationRulesMap = {
	[FieldBBErrorType.required]: undefined;
	[FieldBBErrorType.email]: undefined;
	[FieldBBErrorType.tel]: undefined;
	[FieldBBErrorType.fullName]: undefined;
	[FieldBBErrorType.fileSize]: {
		fileUploadMaxSizeMb: BBUiConfig['componentProps']['fileUploadMaxSizeMb'];
	};
	[FieldBBErrorType.invalidFileType]: {
		fileUploadAllowedTypes: BBUiConfig['componentProps']['fileUploadAllowedTypes'];
	};
	[FieldBBErrorType.genericError]: undefined;
};
type ValidationFn<K extends FieldBBErrorType> = (value: ValidationMap[K], rules: ValidationRulesMap[K]) => boolean;
export type Validations = {
	[K in FieldBBErrorType]: ValidationFn<K>;
};
export type State = typeof initialState;
export type ValidationResultType = { isValid: boolean; errors: State['errors'] };
export type ValidateFnType = (formData: FormDataT) => Promise<ValidationResultType>;
export type RegisterFieldFnType = (field: BBCommonProps) => void;
export type FormCardContextType = typeof initialState &
	Partial<{
		validate: ValidateFnType;
		registerField: RegisterFieldFnType;
		setFieldError?: (fieldId: string, errorType: FieldBBErrorType) => void;
		clearFieldError?: (fieldId: string) => void;
	}> & {
		isUploadingFiles: boolean;
		addToUploadQueue: (id: string) => void;
		removeFromUploadQueue: (id: string) => void;
		isFileUploading: (id: string) => boolean;
	};
